import { clinicNav } from '@/router/rotas';
import { ShellDoProduto } from './ShellDoProduto';

export function ClinicShell() {
    return <ShellDoProduto nav={clinicNav} />;
}
